import React from 'react';
import { SearchBar } from '@vp/omnisearch';
import { FluidImage, FlexBox, VisuallyHidden, H1, H2, Typography } from '@vp/swan'
import "../styles/error-page.scss";

const ErrorPage = props => {
  const { headline, subcopy, cta, searchText, errorImage, help, homeUrl, locale, title, tenant } = props;
  
  return (
    <FlexBox className="error-page" flexDirection="column" mt={8} justifyContent="space-between">
      <VisuallyHidden>
        <H1>
          {title.text}
        </H1>
      </VisuallyHidden>
      <FlexBox justifyContent="center" mt={"6"} className="error-page-image" >
        <FluidImage src={errorImage} alt="" />
      </FlexBox>
      <H2 className="error-page-headline" fontSize={"x3large"}>
        {headline.text}
      </H2>
      <Typography fontSize={"standard"} className="error-page-headline-subtext">
        {subcopy.text}
      </Typography>
      <FlexBox justifyContent="center">
        <div className="search-container">
          <SearchBar
            veilEnabled={tenant === "vistaprint"}
            flyoutEnabled={tenant === "vistaprint"}
            locale={locale}
            searchLabel={searchText.text}
            minCharLength={3}
            instanceId="search"
            flyoutSiteAnalyticsEventName="search-flyout-open"
            />
        </div>
      </FlexBox>
      <div className="error-page-cta">
        <a className="error-page__cta" href={homeUrl}>
          {cta.text}
        </a>
      </div>
      <div 
        dangerouslySetInnerHTML={{
          __html: help.text
        }} >
      </div>
    </FlexBox>
  )
}

export default ErrorPage
